/*
 * @author bai <ghimping@alpstein.my>
 * @link https://www.alpstein.my
 * @copyright Copyright (c) Alpstein Software
 *            _____                    _____                    _____
 *           /\    \                  /\    \                  /\    \
 *          /::\    \                /::\    \                /::\    \
 *         /::::\    \              /::::\    \               \:::\    \
 *        /::::::\    \            /::::::\    \               \:::\    \
 *       /:::/\:::\    \          /:::/\:::\    \               \:::\    \
 *      /:::/__\:::\    \        /:::/__\:::\    \               \:::\    \
 *     /::::\   \:::\    \      /::::\   \:::\    \              /::::\    \
 *    /::::::\   \:::\    \    /::::::\   \:::\    \    ____    /::::::\    \
 *   /:::/\:::\   \:::\ ___\  /:::/\:::\   \:::\    \  /\   \  /:::/\:::\    \
 *  /:::/__\:::\   \:::|    |/:::/  \:::\   \:::\____\/::\   \/:::/  \:::\____\
 *  \:::\   \:::\  /:::|____|\::/    \:::\  /:::/    /\:::\  /:::/    \::/    /
 *   \:::\   \:::\/:::/    /  \/____/ \:::\/:::/    /  \:::\/:::/    / \/____/
 *    \:::\   \::::::/    /            \::::::/    /    \::::::/    /
 *     \:::\   \::::/    /              \::::/    /      \::::/____/
 *      \:::\  /:::/    /               /:::/    /        \:::\    \
 *       \:::\/:::/    /               /:::/    /          \:::\    \
 *        \::::::/    /               /:::/    /            \:::\    \
 *         \::::/    /               /:::/    /              \:::\____\
 *          \::/____/                \::/    /                \::/    /
 *           ~~                       \/____/                  \/____/
 *
 */

import React, { Component } from "react";
import PropTypes from "prop-types";
import { WhiteSpace, Button, Toast, TextareaItem } from "antd-mobile";
import { FormattedMessage, injectIntl } from "react-intl";
import { connect } from "react-redux";
import styled from "styled-components";
import StarRatingComponent from "react-star-rating-component";
import Theme from "../../utils/Theme";
import * as selectors from "../../selectors";
import * as reviewAction from "../../actions/review";
import "./index.css";
import LoadingIndicator from "../../components/LoadingIndicator";

const StyledContainer = styled.div`
  width: 100%;
  display: flex;
  overflow-x: hidden;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
`;

const StyledFormContainer = styled(StyledContainer)`
  background: white;
`;

const StyledInstruction = styled.span`
  color: grey;
  font-size: 1em;
`;

const StyledRatingContainer = styled.div`
  font-size: 2.1em;
`;

const StyledCommentTitle = styled.span`
  margin-top: 10%;
  margin-left: 15px;
  align-self: flex-start;
  color: gray;
  font-size: 1em;
`;

const StyledRoundedButton = styled(Button)`
  && {
    cursor: pointer;
    font-size: 1em !important;
    border-radius: 25px !important;
    color: white !important;
  }
`;

const StyledSubmitButton = styled(StyledRoundedButton)`
  && {
    width: 85%;
    background-color: ${Theme.PrimaryColor};
  }
`;

class ReviewPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      animationClass: null,
      rating: 0,
      comment: null
    };
  }

  componentDidMount() {
    this.configureNavBar();
    this.setState({ animationClass: "slide-in-right" });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { history } = this.props;

    if (nextProps.submitReviewStatus !== this.props.submitReviewStatus) {
      if (nextProps.submitReviewStatus) {
        history.goBack();
      }
    }
  }

  configureNavBar = () => {
    const { navbarConfig, showTabbar, showNavbar } = this.props;
    const navTitle = (
      <FormattedMessage
        id="review.title"
        defaultMessage="Write a review"
        description="Write review title"
      />
    );

    navbarConfig(navTitle, null, null, () => this.onBackPressed(), null);
    showNavbar(true);
    showTabbar(false);
  };

  onBackPressed = () => {
    const { history } = this.props;
    this.setState({ animationClass: "slide-out-right" });

    window.setTimeout(() => {
      history.goBack();
    }, 300);
  };

  checkSubmitAvailability = () => {
    const { rating } = this.state;
    return rating === 0;
  };

  onSubmit = () => {
    const { submitReview, match } = this.props;
    const { rating, comment } = this.state;
    const reviewID = match && match.params ? match.params.id : null;

    submitReview(reviewID, {
      rating: rating,
      comment: comment
    });
  };

  onRatingChange = value => {
    this.setState({ rating: value });
  };

  onCommentsChange = value => {
    this.setState({ comment: value });
  };

  render() {
    const { animationClass } = this.state;
    const { intl, loading } = this.props;

    return (
      <StyledContainer
        className={animationClass !== null ? animationClass : false}
        onAnimationEnd={() => this.setState({ animationClass: null })}
      >
        {loading ? <LoadingIndicator /> : null}
        <StyledFormContainer>
          <WhiteSpace size={"lg"} />
          <StyledInstruction>
            <FormattedMessage
              id="review.instruction"
              defaultMessage="Tap a star to rate"
              description="Review instruction"
            />
          </StyledInstruction>
          <WhiteSpace size={"lg"} />
          <StyledRatingContainer>
            <StarRatingComponent
              name={"productItemRating"}
              starCount={5}
              starColor={Theme.PrimaryColor}
              onStarClick={this.onRatingChange}
              emptyStarColor={"lightgrey"}
            />
          </StyledRatingContainer>
          <WhiteSpace size={"lg"} />
          <StyledCommentTitle>
            <FormattedMessage id="review.description.title" />
          </StyledCommentTitle>
          <TextareaItem
            className={"review-description"}
            autoHeight
            rows={5}
            onChange={this.onCommentsChange}
            placeholder={intl.formatMessage({
              id: "review.description.placeholder",
              defaultMessage: "Review (Optional)",
              description: "Review Description Placeholder"
            })}
          />
        </StyledFormContainer>
        <WhiteSpace size={"lg"} />
        <WhiteSpace size={"lg"} />
        <StyledSubmitButton
          disabled={loading || this.checkSubmitAvailability()}
          loading={loading}
          activeStyle={{ backgroundColor: Theme.ActivePrimary }}
          onClick={() => this.onSubmit()}
        >
          {loading ? (
            <FormattedMessage
              id="app.loading"
              defaultMessage="Loading"
              description="Loading Title"
            />
          ) : (
            <FormattedMessage
              id="app.submit"
              defaultMessage="Submit"
              description="Submit button title"
            />
          )}
        </StyledSubmitButton>
      </StyledContainer>
    );
  }
}

ReviewPage.propTypes = {
  intl: PropTypes.object,
  showNavbar: PropTypes.func.isRequired,
  showTabbar: PropTypes.func.isRequired,
  navbarConfig: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  submitReviewStatus: PropTypes.bool,
  loading: PropTypes.bool,
  submitReview: PropTypes.func
};

function mapStateToProps(state) {
  return {
    submitReviewStatus: selectors.getReviewSubmitReviewStatus(state),
    loading: selectors.getReviewSubmitReviewLoading(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    submitReview: (reviewID, data) =>
      dispatch(reviewAction.postSubmitReviewRequest(reviewID, data))
  };
}

export default injectIntl(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ReviewPage)
);



// WEBPACK FOOTER //
// ./src/containers/ReviewPage/index.js